package screens.auth

import androidx.compose.runtime.*
import com.example.readingnotes.presentation.auth.AuthEvent
import com.example.readingnotes.presentation.auth.AuthViewModel
import com.example.readingnotes.resources.Strings
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import styles.AppStyleSheet

@Composable
fun TotpVerifyScreen(
    onVerifySuccess: () -> Unit,
    onBackClick: () -> Unit,
    authViewModel: AuthViewModel,
) {
    val state by authViewModel.state.collectAsState()

    // Navigate on successful verification
    if (state.totpVerified) {
        LaunchedEffect(Unit) {
            onVerifySuccess()
        }
    }

    Div({ classes(AppStyleSheet.loginContainer) }) {
        Button({
            classes(AppStyleSheet.backButton)
            onClick { onBackClick() }
        }) { Text("← 戻る") }

        Div({ classes(AppStyleSheet.loginForm) }) {
            H2({ classes(AppStyleSheet.loginTitle) }) { Text(Strings.Auth.totpVerify) }
            P({ classes(AppStyleSheet.totpDescription) }) {
                Text(Strings.Auth.totpVerifyDescription)
            }

            // TOTP code input
            Div({ classes(AppStyleSheet.formGroup) }) {
                Label("totp-input") {
                    Text(Strings.Auth.totpCode)
                }

                Input(type = InputType.Text) {
                    id("totp-input")
                    classes(AppStyleSheet.totpInput)
                    value(state.totpCodeInput)
                    maxLength(6)
                    attr("pattern", "[0-9]{6}")
                    attr("inputmode", "numeric")
                    attr("autocomplete", "one-time-code")
                    attr("required", "true")
                    attr("aria-label", Strings.Auth.ariaTotpCode)
                    attr("aria-describedby", "totp-hint")
                    onInput { authViewModel.onEvent(AuthEvent.OnTotpCodeChanged(it.value)) }
                    if (state.isLoading) {
                        disabled()
                    }
                }

                // TOTP hint
                P({
                    id("totp-hint")
                    classes(AppStyleSheet.inputHint)
                }) {
                    Text(Strings.Auth.totpVerifyDescription)
                }
            }

            // Error message
            if (state.errorMessage != null) {
                Div({
                    classes(AppStyleSheet.formError)
                    attr("role", "alert")
                    attr("aria-live", "assertive")
                }) { Text(state.errorMessage!!) }
            }

            // Verify button
            Div({ classes(AppStyleSheet.loginButtonGroup) }) {
                Button({
                    classes(AppStyleSheet.submitButton)
                    onClick { authViewModel.onEvent(AuthEvent.OnVerifyTotpSubmit) }
                    if (state.isLoading || state.totpCodeInput.length != 6) {
                        disabled()
                    }
                }) {
                    Text(if (state.isLoading) Strings.Auth.verifyLoading else Strings.Auth.verifyButton)
                }
            }
        }
    }
}
